import {
  DEFAULT_PAYMENT_COUNTRY,
  DEFAULT_PAYMENT_CURRENCY,
} from './default-codes/default-payment-codes';
import { BILLING_COUNTRIES, Currencies, ISOs, PaymentISOs } from './generated/constants';

export * from './generated/constants';

/** Re-export for GraphQL generated code (value import so runtime has IsoCountryCode). */
export { ISOs as IsoCountryCode };

export const CATERING_PICKUP_NOTES_LIMIT = 200;
export const CATERING_PICKUP_NAME_LIMIT = 50;

export {
  DEFAULT_PAYMENT_COUNTRY,
  DEFAULT_PAYMENT_CURRENCY,
} from './default-codes/default-payment-codes';

export const getCountryAndCurrencyCodes = (
  billingCountry: ISOs
): { countryCode: PaymentISOs; currencyCode: Currencies } => {
  const defaultCodes = {
    countryCode: DEFAULT_PAYMENT_COUNTRY,
    currencyCode: DEFAULT_PAYMENT_CURRENCY,
  };
  return BILLING_COUNTRIES[billingCountry] || defaultCodes;
};

export const defaultLocaleKeys = {
  postalCode: 'postalCode',
  region: 'province',
};

export const postalCodeStringLocaleKey = {
  [ISOs.USA]: 'zipCode',
};

export const regionStringLocaleKey = {
  [ISOs.USA]: 'state',
  [ISOs.CHE]: 'canton',
};

export const defaultInputProperties = {
  postalCode: { maxLength: '5', pattern: '[0-9]*' },
  region: { maxLength: '2' },
};

export const postalCodeInputProperties = {
  [ISOs.CAN]: { maxLength: '7' },
  [ISOs.GBR]: { maxLength: '10' },
  [ISOs.CHE]: { maxLength: '4', pattern: '[0-9]*' },
};

export const regionInputProperties = {};
